import { compact } from 'lodash';
import { useMemo } from 'react';

import { useIssuedInvoicesNavTab } from '~legacy.invoice';

import { PaymentsAndInvoicesNavParams, PaymentsAndInvoicesNavTab } from './PaymentsAndInvoicesPanel.types';

export const usePaymentsAndInvoicesTabs = (): PaymentsAndInvoicesNavTab[] => {
   const issuedInvoicesNavTab = useIssuedInvoicesNavTab({ param: PaymentsAndInvoicesNavParams.INVOICES });

   return useMemo(() => compact([issuedInvoicesNavTab]), [issuedInvoicesNavTab]);
};
